import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { useAlerts } from '../hooks/useAlerts';

const TopBar = ({ activeAccount }) => {
  const { permission, requestPermission } = useAlerts();

  const handleDeviceTest = async (type) => {
    try {
      if (type === 'camera' || type === 'mic') {
        const constraints = { video: type === 'camera', audio: type === 'mic' };
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        // Stop immediately, just testing permission
        stream.getTracks().forEach(track => track.stop());
        alert(`${type === 'camera' ? 'Camera' : 'Microphone'} access granted to wrapper.`);
      }
    } catch (err) {
      alert(`Permission denied or device not found: ${err.message}`);
    }
  };

  return (
    <div className="h-14 bg-gray-900 border-b border-gray-800 flex items-center justify-between px-4 text-white z-10 w-full shrink-0">
      <div className="flex items-center space-x-3">
        <div className={`w-3 h-3 rounded-full ${activeAccount.status === 'online' ? 'bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.6)]' : 'bg-gray-500'}`}></div>
        <span className="font-medium">{activeAccount.name}</span>
        <span className="text-xs text-gray-400 px-2 py-0.5 bg-gray-800 rounded-full border border-gray-700">
          Session Active
        </span>
      </div>

      <div className="flex items-center space-x-2">
        <button 
          onClick={() => handleDeviceTest('camera')}
          className="p-2 hover:bg-gray-800 rounded-lg transition-colors text-gray-400 hover:text-white group relative"
          title="Wrapper Camera Access"
        >
          <SafeIcon icon="FiCamera" className="text-lg" />
        </button>
        <button 
          onClick={() => handleDeviceTest('mic')}
          className="p-2 hover:bg-gray-800 rounded-lg transition-colors text-gray-400 hover:text-white group relative"
          title="Wrapper Microphone Access"
        >
          <SafeIcon icon="FiMic" className="text-lg" />
        </button>
        <div className="w-px h-6 bg-gray-700 mx-2"></div>
        <button 
          onClick={requestPermission}
          className={`p-2 rounded-lg transition-colors flex items-center space-x-2 ${
            permission === 'granted' ? 'text-blue-400 hover:bg-gray-800' : 'text-gray-400 hover:bg-gray-800'
          }`}
          title="Local Alerts Permission"
        >
          <SafeIcon icon={permission === 'granted' ? 'FiBell' : 'FiBellOff'} className="text-lg" />
        </button>
      </div>
    </div>
  );
};

export default TopBar;